import {Injectable} from "@angular/core";
import {HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {AuthenticationService} from "../authentication-service";
import {HttpService} from "../http.service";
import {LoginRequest} from "../../shared/model/request/login-request.model";
import {AuthenticationResponse} from "../../shared/model/response/auth/authentication-response.model";
import {RegisterModelRequest} from "../../shared/model/request/register.model";
import {ApiResponse} from "../../shared/model/response/ApiResponse";
import {ResetPasswordRequest} from "../../shared/model/request/reset-password.request";
import {AccountActivationRequestModel} from "../../shared/model/request/account-activation-request.model";
import {AccountResponse} from "../../shared/model/response/account-response.model";


/**
 * The access service provides functions to handle user account access to the application
 * such as register, account activation.
 */
@Injectable({providedIn: "root"})
export class AccessService {

  private version = "/api/v1/"
  private host = environment.host + this.version

  private url: string = this.host + "accounts"
  private authUrl: string = this.host + "auth"
  private authUrlGoogle: string = this.host + "auth/google"
  private refreshTokenUrl: string = this.host + "auth/refresh-token"
  private activateAccountUrl: string = this.host + "access/activate-account"
  private requestAccountActivationUri: string = this.host + "access/request-account-activation"
  private terminateSessionsUrl: string = this.host + "access/terminate-sessions"
  private requestPasswordRecover: string = this.host + "login/password/request"
  private resetPassword: string = this.host + "login/password/reset"

  constructor(
    private authService: AuthenticationService,
    private genericHttp: HttpService
  ) {
  }

  //attempt to log in with backend
  login(credentials: LoginRequest): Observable<AuthenticationResponse> {
    return this.genericHttp.post(this.authUrl, credentials, {shouldShowLoading: true});
  }

  //google login
  googleLogin(idToken: string): Observable<AuthenticationResponse> {
    return this.genericHttp.post(this.authUrlGoogle, {idToken: idToken}, {shouldShowLoading: true});
  }

  //Use the refresh token to get a new accessToken
  refreshToken(): Observable<any> {
    let headers: HttpHeaders = new HttpHeaders({'Skip-Interceptor': 'true'})
    const requestBody = {refreshToken: this.authService.getRefreshToken()}

    return this.genericHttp.post(this.refreshTokenUrl, requestBody, {observe: "body", headers: headers})
  }

  //attempt to logs out the user
  logout() {
    this.authService.removeSession()
  }

  //register account through forms.
  register(register: RegisterModelRequest): Observable<ApiResponse<AccountResponse>> {
    return this.genericHttp.post(this.url, register, {shouldShowLoading : true})
  }

  //request token to activate account, well be sent through email.
  requestAccountActivation(requestBody: AccountActivationRequestModel): Observable<ApiResponse<any>> {
    return this.genericHttp.put(this.requestAccountActivationUri, requestBody, {shouldShowLoading: true})

  }

  activateAccount(body: {phoneNumber: string, pin: string}): Observable<ApiResponse<any>> {
    return this.genericHttp.put(this.activateAccountUrl, body, {shouldShowLoading: true})
  }

  //termine all sessions
  terminateUserSessions(): Observable<ApiResponse<AuthenticationResponse>> {
    return this.genericHttp.put(this.terminateSessionsUrl, null, {shouldShowLoading: true})
  }

  //Request password | recovery
  passwordRecoveryRequest(phoneNumber: string): Observable<ApiResponse<any>> {
    return this.genericHttp.post(this.requestPasswordRecover, {phoneNumber: phoneNumber}, {shouldShowLoading: true})
  }

  // Reset Password | recovery
  changePassword(body: ResetPasswordRequest): Observable<ApiResponse<any>> {
    return this.genericHttp.put(this.resetPassword, body, {shouldShowLoading: true})
  }

}
